import React, { useState, useEffect } from 'react'
import TabsComponent from '../../Components/Categories/TabsComponent/TabsComponent'
import ServiceProviders from '../../Components/ServiceProviders/ServiceProviders'
import styles from '../../Components/ServiceProviders/ServiceProviders.module.css'
import SearchComponent from '../../Components/Utilities/SearchComponent';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { getAllServiceproviders } from '../../redux/Slices/Services/thunk';
import { useTranslation } from "react-i18next";


const ServiceProvidersPage = () => {
    const { t, i18n } = useTranslation();
    const currentLanguage = i18n.language;
    const location = useLocation();
    console.log("location",location)
    const { isEdit, servicesId, servicesId2, reservationNum } = location.state || {};
    const dispatch = useDispatch();
    const navigate = useNavigate();


  const [externalTab, setExternalTab] = useState(2);
  const ServicesCard = JSON.parse(localStorage.getItem("ServicesCard"));
  const isEditServisePreducer = JSON.parse(sessionStorage.getItem('isEditServisePreducer'));
  const cartFromCart = JSON.parse(sessionStorage.getItem('cartFromCart'));
  console.log("isEditServisePreducer",isEditServisePreducer, "cartFromCart", cartFromCart)

  let id;
  if(isEdit){
    
    id = servicesId?.trim();
  }else if(isEditServisePreducer){
    id = cartFromCart?.itm_srl?.trim();
  }else{
    id = ServicesCard?.itm_srl?.trim();
  }
  const numberId = Number(id);
  console.log("id",id)
  console.log("ServicesCard",ServicesCard)


  useEffect(() => {
    if(!isEdit && !isEditServisePreducer){
      if(!ServicesCard){
        setExternalTab(1)
        navigate('/services')
    }
    }
    if (numberId) {
      dispatch(getAllServiceproviders({ serviceId: numberId }));
    }
  }, [numberId, dispatch]);

  const handleCardClick = (tabIndex) => {
    setExternalTab(tabIndex);
  };


  return (
    <div className='flex-grow-1'>
       <div style={{ padding: '20px', maxWidth: '1000px', margin:"auto" }}>

      </div>
      <div style={{display:"flex", justifyContent:"center", alignItems:"center"}}>
{!isEdit &&   <TabsComponent externalTab={externalTab} setExternalTab={setExternalTab} isEditServisePreducer={isEditServisePreducer} />}
      </div>
    <div className={styles.loginContainer}>
    <div className={styles.loginHeader}>{t('service_providers')}</div>
    <div className={styles.loginSecHeader}>{t('service_providers_description')}</div>


      </div>
     
      <ServiceProviders  onCardClick={handleCardClick} isEdit={isEdit} servicesId={servicesId} servicesId2={servicesId2} reservationNum={reservationNum} isEditServisePreducer={isEditServisePreducer} cartFromCart={cartFromCart}/>
      
    </div>
  )
}
export default ServiceProvidersPage;
